import * as React from 'react'
import { MenuListProps, OptionProps } from 'react-select'
import { FixedSizeList as List, ListChildComponentProps } from 'react-window'
import { EcgTest } from 'webportalclient'

export const PerformanceSelect = (props: MenuListProps<EcgTest, false>) => {
    const itemHeight = 35;
    const { options, children, maxHeight, getValue } = props;
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * itemHeight;

    return Array.isArray(children) ? (
        <div style={{ paddingTop: 4 }}>
            <List
                height={maxHeight}
                itemCount={children.length}
                itemSize={itemHeight}
                initialScrollOffset={initialOffset}
                width="100%"
            >
                {({ index, style }: ListChildComponentProps) => <div style={{ ...style }}>{children[index]}</div>}
            </List>
        </div>
    ) : null
}

export const PerformanceOption = (props: OptionProps<EcgTest>) => {
    const { children, innerProps, getStyles, isSelected } = props;
    delete props.innerProps.onMouseMove;
    delete props.innerProps.onMouseOver;
    const [isHovered, setIsHovered] = React.useState(false);
    const [isPressed, setIsPressed] = React.useState(false);

    const customStyles = {
        ...getStyles('option', props),
        ...(isSelected || isHovered || isPressed
            ? {
                backgroundColor: isSelected ? '#abbde9' : isPressed ? '#B2D4FF' : '#DDEBFF',
            }
            : {}),
        color: isSelected ? 'white' : undefined,
    }

    return (
        <div
            style={customStyles as React.CSSProperties}
            role="button"
            id={innerProps.id}
            tabIndex={innerProps.tabIndex}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onMouseDown={() => setIsPressed(true)}
            onMouseUp={() => setIsPressed(false)}
            onClick={innerProps.onClick}
            onKeyDown={innerProps.onKeyDown}
        >
            {children}
        </div>
    )
}
